import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ItemPermissionContainerModel } from '../../../../../../models/aggregates/item-permission/item-permission-container.model';

@Injectable({
  providedIn: 'root'
})
export class ItemHostPermissionService extends BaseApiTemplateService<ItemPermissionContainerModel> {

  readonly url = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-perm/host/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-perm/host/backoffice-ep';
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-perm/host/backoffice-ep';
    this.httpClient = http;
  }

  getItemPerm(tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<ItemPermissionContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/query?calcTotalRecords=true';
    }
    return this.httpClient.get<ApiResponseModel<ItemPermissionContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}